(() => {
  const primaryLimit = 6;
  const roastGroups = { light: ['light', 'light-medium'], medium: ['light-medium', 'medium', 'medium-dark'], dark: ['medium-dark', 'dark'] };
  const chosen = (value) => value && value !== 'any';
  const effectiveAnswers = (answers) => ({ ...answers, roast: answers.style === 'flavored' ? 'any' : answers.roast });
  function selectCoffees(products, rawAnswers) {
    const answers = effectiveAnswers(rawAnswers);
    const candidates = products.filter((product) => (!chosen(answers.style) || product.style === answers.style) && (!chosen(answers.format) || (product.packageFormat || 'bagged') === answers.format) && product.variants.length).map((product, index) => {
      const familyMatch = !chosen(answers.family) || product.families.includes(answers.family);
      const roastMatch = !chosen(answers.roast) || (roastGroups[answers.roast] || []).includes(product.roast);
      return { product, familyMatch, roastMatch, exact: familyMatch && roastMatch, score: (chosen(answers.family) && familyMatch ? 5 : 0) + (chosen(answers.roast) && roastMatch ? 3 : 0), index };
    });
    const exact = candidates.filter((match) => match.exact);
    const broad = !chosen(answers.style) && !chosen(answers.family) && !chosen(answers.roast);
    let mode = 'exact';
    let primary = [];
    const labeled = (matches, group) => matches.map((match) => ({ ...match, group }));
    if (broad) {
      mode = 'starting';
      const starters = [
        (product) => product.style === 'traditional' && roastGroups.light.includes(product.roast),
        (product) => product.style === 'traditional' && roastGroups.dark.includes(product.roast),
        (product) => product.style === 'flavored' && product.roast === 'medium'
      ];
      starters.forEach((test) => {
        const match = candidates.find((candidate) => test(candidate.product) && !primary.includes(candidate));
        if (match) primary.push(match);
      });
      primary = labeled([...primary, ...candidates.filter((match) => !primary.includes(match))].slice(0, primaryLimit), 'starting');
    } else if (exact.length) {
      primary = exact.slice(0, primaryLimit);
    } else if (chosen(answers.family) && chosen(answers.roast)) {
      const flavor = candidates.filter((match) => match.familyMatch);
      const roast = candidates.filter((match) => match.roastMatch);
      if (flavor.length && roast.length) {
        mode = 'tradeoff';
        primary = [...labeled(flavor.slice(0, 2), 'flavor'), ...labeled(roast.slice(0, 1), 'roast')];
      } else if (flavor.length || roast.length) {
        mode = 'near';
        primary = flavor.length ? labeled(flavor.slice(0, 3), 'flavor') : labeled(roast.slice(0, 3), 'roast');
      }
    }
    if (!primary.length && candidates.length) {
      mode = 'near';
      primary = labeled(candidates.slice().sort((a, b) => b.score - a.score || a.index - b.index).slice(0, 3), 'alternative');
    }
    const selected = new Set(primary.map((match) => match.product));
    return { primary, more: exact.filter((match) => !selected.has(match.product)), mode, broad };
  }
  const rankCoffees = (products, answers) => selectCoffees(products, answers).primary;
  if (typeof module !== 'undefined' && module.exports) module.exports = { rankCoffees, selectCoffees };
  if (typeof document === 'undefined') return;
  function initialize(root) {
    if (root.dataset.finderReady) return;
    const textNode = root.querySelector('[data-finder-text]');
    if (!textNode) return;
    let words;
    let products;
    try {
      const decodeText = (value) => { if (typeof value === 'string') { const decoder = document.createElement('textarea'); decoder.innerHTML = value; return decoder.value; } return Object.fromEntries(Object.entries(value).map(([key, text]) => [key, decodeText(text)])); };
      words = decodeText(JSON.parse(textNode.textContent));
      const variants = new Map([...root.querySelectorAll('[data-finder-variants]')].map((node) => [node.dataset.finderVariants, JSON.parse(node.textContent)]));
      products = [...root.querySelectorAll('[data-finder-product]')].map((template) => {
        const tags = template.dataset.tags.split(',');
        const style = tags.includes('gg-finder-style-flavored') ? 'flavored' : tags.includes('gg-finder-style-traditional') ? 'traditional' : '';
        const prefix = style === 'flavored' ? 'gg-finder-flavor-' : 'gg-finder-note-';
        return { template, handle: template.dataset.handle, packageFormat: template.dataset.coffeeFormat || 'bagged', style, families: tags.filter((tag) => tag.startsWith(prefix)).map((tag) => tag.slice(prefix.length)), roast: (tags.find((tag) => tag.startsWith('gg-finder-roast-')) || '').replace('gg-finder-roast-', ''), variants: variants.get(template.dataset.handle) || [] };
      }).filter((product) => product.style && product.variants.length);
    } catch {
      return;
    }
    root.dataset.finderReady = 'true';
    const wizard = root.querySelector('[data-finder-wizard]');
    const form = root.querySelector('[data-finder-form]');
    const steps = [...root.querySelectorAll('[data-step]')];
    const next = root.querySelector('[data-finder-next]');
    const back = root.querySelector('[data-finder-back]');
    const restart = root.querySelector('[data-finder-restart]');
    const results = root.querySelector('[data-finder-results]');
    const cards = root.querySelector('[data-finder-cards]');
    const progress = root.querySelector('[data-finder-progress]');
    const more = root.querySelector('[data-finder-more]');
    const moreCards = root.querySelector('[data-finder-more-cards]');
    const builder = root.querySelector('[data-finder-builder]');
    const builderLink = root.querySelector('[data-finder-builder-link]');
    const pending = root.querySelector('[data-finder-kcups-pending]');
    const answers = { format: 'any', style: 'any', family: 'any', roast: 'any' };
    let current = 0;
    let completed = false;
    const path = () => steps.filter((step) => step.dataset.step !== 'roast' || answers.style !== 'flavored');
    const noKcups = () => !products.some((product) => product.packageFormat === 'kcups');
    const focus = (node) => { node.focus({ preventScroll: true }); node.scrollIntoView({ block: 'start', behavior: 'instant' }); };
    function updateNext() {
      const active = path();
      current = Math.min(current, active.length - 1);
      const step = active[current];
      next.disabled = !step.querySelector('input:checked');
      progress.textContent = words.step.replace('__CURRENT__', current + 1).replace('__TOTAL__', active.length);
      root.querySelector('[data-finder-track]').style.width = `${((current + 1) / active.length) * 100}%`;
      root.querySelector('[data-finder-info]').hidden = !['style', 'family'].includes(step.dataset.step);
      next.textContent = step.dataset.step === 'format' && answers.format === 'kcups' && noKcups() ? words.check_availability : current === active.length - 1 ? words.show : words.next;
    }
    function showStep(index, shouldFocus = true) {
      const active = path();
      current = Math.max(0, Math.min(index, active.length - 1));
      completed = false;
      wizard.hidden = false;
      results.hidden = true;
      builder.hidden = true;
      steps.forEach((step) => {
        step.hidden = step !== active[current];
        step.querySelectorAll('input').forEach((input) => { input.required = !step.hidden; });
      });
      back.hidden = current === 0;
      restart.hidden = current === 0 && !form.querySelector('input:checked');
      updateNext();
      if (shouldFocus) focus(active[current].querySelector('[data-step-title]'));
    }
    function showResults() {
      const preferences = effectiveAnswers(answers);
      const selection = selectCoffees(products, preferences);
      const matches = selection.primary;
      const kcupsPending = answers.format === 'kcups' && noKcups();
      cards.replaceChildren();
      moreCards.replaceChildren();
      more.open = false;
      const renderCard = ({ product, familyMatch, roastMatch, group }) => {
        const card = product.template.content.firstElementChild.cloneNode(true);
        const groupLabel = card.querySelector('[data-finder-match-group]');
        groupLabel.hidden = !group;
        groupLabel.textContent = group ? words[`group_${group}`] : '';
        card.querySelector('[data-finder-kind]').textContent = words[product.style];
        card.querySelector('[data-finder-profile]').textContent = product.families.length ? `${words[product.style === 'flavored' ? 'flavor_families' : 'note_families']}: ${product.families.map((family) => words.families[family]).filter(Boolean).join(' · ')}` : words.no_family;
        card.querySelector('[data-finder-roast]').textContent = words.roasts[product.roast] || words.unknown_roast;
        const reasons = [];
        if (chosen(preferences.family)) reasons.push(familyMatch ? words.family_match.replace('__FAMILY__', words.families[preferences.family]) : words.family_other);
        if (chosen(preferences.roast)) reasons.push(!product.roast ? words.roast_unknown : roastMatch ? words.roast_match : words.roast_other);
        reasons.push(words.format_match.replace('__FORMAT__', words.formats[product.packageFormat]));
        const list = card.querySelector('[data-finder-reasons]');
        reasons.forEach((reason) => { const item = document.createElement('li'); item.textContent = reason; list.append(item); });
        return card;
      };
      matches.forEach((match) => cards.append(renderCard(match)));
      more.hidden = !selection.more.length;
      root.querySelector('[data-finder-more-summary]').textContent = words[selection.broad ? 'more_all' : 'more_exact'].replace('__COUNT__', selection.more.length);
      more.ontoggle = () => {
        if (more.open && !moreCards.childElementCount) selection.more.forEach((match) => moreCards.append(renderCard(match)));
      };
      root.querySelector('[data-finder-summary]').textContent = kcupsPending ? words.kcups_pending : !matches.length ? words.empty : words[selection.mode];
      const heading = root.querySelector('[data-finder-result-heading]');
      heading.textContent = kcupsPending ? words.kcups_heading : words.results;
      pending.hidden = !kcupsPending;
      const footnote = root.querySelector('[data-finder-footnote]');
      footnote.textContent = answers.format === 'kcups' ? words.kcups_footnote : words.footnote;
      footnote.hidden = kcupsPending;
      wizard.hidden = true;
      results.hidden = false;
      builder.hidden = false;
      if (builderLink) {
        builderLink.href = answers.format === 'kcups' ? '/products/k-cup-bulk-box' : '/collections/build-a-box';
        builderLink.textContent = answers.format === 'kcups' ? words.builder_kcups_button || words.builder_button : words.builder_button;
      }
      completed = true;
      restart.hidden = false;
      focus(heading);
    }
    function advance() {
      if (completed) return;
      const active = path();
      const step = active[current];
      const selected = step.querySelector('input:checked');
      if (!selected) return;
      answers[step.dataset.step] = selected.value;
      if (step.dataset.step === 'format' && answers.format === 'kcups' && noKcups()) showResults();
      else if (current < path().length - 1) showStep(current + 1);
      else showResults();
    }
    function reconcileRestoredChoices() {
      if (!root.isConnected) return;
      steps.forEach((step) => { answers[step.dataset.step] = step.querySelector('input:checked')?.value || 'any'; });
      if (!completed) { updateNext(); restart.hidden = current === 0 && !form.querySelector('input:checked'); }
    }
    window.addEventListener('pageshow', () => requestAnimationFrame(reconcileRestoredChoices));
    form.addEventListener('focusin', reconcileRestoredChoices);
    form.addEventListener('submit', (event) => { event.preventDefault(); advance(); });
    form.addEventListener('change', () => { reconcileRestoredChoices(); restart.hidden = false; });
    back.addEventListener('click', () => showStep(current - 1));
    root.querySelector('[data-finder-edit]').addEventListener('click', () => showStep(answers.format === 'kcups' && noKcups() ? 0 : path().length - 1));
    root.querySelector('[data-finder-bagged]').addEventListener('click', () => {
      answers.format = 'bagged';
      steps.find((step) => step.dataset.step === 'format').querySelectorAll('input').forEach((input) => { input.checked = input.value === 'bagged'; });
      showStep(1);
    });
    restart.addEventListener('click', () => { form.reset(); steps.forEach((step) => { step.querySelectorAll('input[type="radio"]').forEach((input) => { input.checked = input.defaultChecked; }); }); Object.keys(answers).forEach((key) => { answers[key] = 'any'; }); cards.replaceChildren(); moreCards.replaceChildren(); more.open = false; more.hidden = true; showStep(0); });
    root.querySelector('[data-finder-fallback]').hidden = true;
    showStep(0, false);
  }
  const mount = (scope = document) => scope.querySelectorAll('[data-coffee-finder]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();

